export default __webpack_public_path__ + "static/media/trash.d0f5b5bb.svg";